import { inject, observer } from 'mobx-react';
import React from 'react'
import { presetTemplates } from '../../utils/TemplateSizes';
import PresetTemplate from '../Inputs/PresetTemplate';
import SizeInput from '../Inputs/SizeInput';

@inject('workAreaStore', 'templateStore', 'store', 'saveStore') @observer
class DesignMenu extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      project: {
        id: ''
      },
      title: '',
      dropdownOpen: false,
      templateOptions: [
        {
          title: 'Social media',
          type: 'social',
          selected: true
        },
        {
          title: 'Business',
          type: 'business',
          selected: false
        },
        {
          title: 'Print',
          type: 'print',
          selected: false
        },
        {
          title: 'Custom size',
          type: 'custom',
          selected: false
        },
      ]
    }
  }

  saveChanges(width, height){
    const { workAreaStore } = this.props
    const w = parseInt(width)
    const h = parseInt(height)
    this.setState({ width, height })
    if (w && h) {
      this.props.workAreaStore.updatePage(w, h)
      this.setState({
        title: workAreaStore.title
      })
    }
  }

  componentDidMount(){
    if(!this.props.templateStore.defaults){
      this.props.templateStore.fetchDefaultTemplates()
    }
    if(this.props.store.designMenuTab){
      const copy = [...this.state.templateOptions]
      const item = copy.find(({ type }) => type === this.props.store.designMenuTab)
      if(item){
        this.select(item)
      }
    }
  }

  closeMenu(){
    this.props.store.modals.toggleAnyModal('menuOpen' ,false)
  }

  toggleDropdown(){
    this.setState({ dropdownOpen: !this.state.dropdownOpen })
  }

  handlePresetClick(width, height){
    this.saveChanges(width, height)
  }

  select(option){
    const { store } = this.props
    if(store.auth || option.type !== 'custom'){ 
      const copy = this.state.templateOptions.map(opt => {
        if(option.type === opt.type){
          opt.selected = true
        }else{
          opt.selected = false
        }
        return opt
      })
      this.setState({ templateOptions: copy })
    }
    if(!store.auth && option.type === 'custom'){
      store.toggleUpgradeModal('register', true)
    }
  }

  getAPIDefaults(active){
    const { templateStore } = this.props
    if(templateStore.defaultsLoading){
      return <div />
    }
    const templates = templateStore.defaults[active.type]
    if(!templates){
      return <div />
    }
    return (
      templates.map((t, idx) => (
        <PresetTemplate 
          key={idx}
          {...t} 
          onClick={this.handlePresetClick.bind(this)}
        />
      ))
    )
  }

  render(){
    const activeItem = this.state.templateOptions.find(({ selected }) => selected)
    const p = this.props.workAreaStore.pages[0]
    let width, height = 0
    if(p){
      width = p.width
      height = p.height
    }
    return (
      <div className='design-menu'>
        <div className='design-menu__side-menu'>
          {
            this.state.templateOptions.map((option, idx) => (
              <div key={idx} className='design-menu__option'>
                {
                  option.selected ? (
                    <span 
                      className='design-menu__selected'
                      >
                      {option.title}
                    </span>
                  )
                  :
                  (
                    <span
                      onClick={() => this.select(option)}
                      className='design-menu__selectable'
                    >
                      {option.title}
                    </span>
                  )
                }
              </div>
            ))
          }
        </div>
        <div className='design-menu__slider'>
          {
            activeItem.type === 'custom' ? (
              <>
                <SizeInput
                  width={width}
                  height={height}
                  save={this.saveChanges.bind(this)}
                />
              </>
            )
            :
            (
              activeItem.type === 'social' ? (
                <div className='design-menu__presets'>
                  {
                    presetTemplates.map((template, idx) => {
                      return template.type === activeItem.type ? (
                        <PresetTemplate 
                          key={idx}
                          {...template} 
                          onClick={this.handlePresetClick.bind(this)}
                        />
                      ):
                      <div/>
                    })
                  }
                </div>
              )
              :
              (
                <div className='design-menu__presets'>
                  {
                    this.getAPIDefaults(activeItem)
                  }
                </div>
              )
            )
          }
        </div>
      </div>
    )
  }

}

export default DesignMenu